import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ChatWindow from "./components/ChatWindow";
import ForecastPage from "./components/ForecastPage";
import Layout from "./components/Layout";
import GroupsPage from "./components/GroupsPage";
import AstroIntelligencePage from "./components/AstroIntelligencePage";
import ProfessionalNumerologyPage from "./components/ProfessionalNumerologyPage";
import AdvancedAlgoRunnerPage from "./components/AdvancedAlgoRunnerPage";
import VoiceAlertsPage from "./components/VoiceAlertsPage";
import AgenticAIDashboard from "./components/AgenticAIDashboard";
import RevenueDashboard from "./components/RevenueDashboard";
import FnOTradingPage from "./components/FnOTradingPage";
import UserProfile from "./components/UserProfile";
import Wallet from "./components/Wallet";
import LandingPage from "./components/LandingPage";
import AuthPage from "./components/AuthPage";
import "./styles/globals.css";

function App() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/chat" element={<ChatWindow />} />
          <Route path="/forecast" element={<ForecastPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/astro-intelligence" element={<AstroIntelligencePage />} />
          <Route path="/numerology" element={<ProfessionalNumerologyPage />} />
          <Route path="/algo-runner" element={<AdvancedAlgoRunnerPage />} />
          <Route path="/voice-alerts" element={<VoiceAlertsPage />} />
          <Route path="/ai-dashboard" element={<AgenticAIDashboard />} />
          <Route path="/revenue" element={<RevenueDashboard />} />
          <Route path="/fno-trading" element={<FnOTradingPage />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/login" element={<AuthPage initialMode="login" />} />
          <Route path="/signup" element={<AuthPage initialMode="signup" />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}

export default App;
